import { useState } from 'react';
import { depoimentosPlanos, estatisticasSatisfacao } from '../../../mocks/depoimentos-planos';

export default function DepoimentosPlanos() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsPerPage = 3;
  const totalPages = Math.ceil(depoimentosPlanos.length / itemsPerPage);

  const nextSlide = () => setCurrentIndex((prev) => (prev + 1) % totalPages);
  const prevSlide = () => setCurrentIndex((prev) => (prev - 1 + totalPages) % totalPages);

  const currentDepoimentos = depoimentosPlanos.slice(
    currentIndex * itemsPerPage,
    (currentIndex + 1) * itemsPerPage
  );

  return (
    <section className="py-24 bg-[#0a0a0a] relative border-t border-[#D4AF37]/10">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(201,164,64,0.04),transparent_60%)]"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="w-10 h-px bg-[#D4AF37]/40"></div>
            <span className="font-['Montserrat'] text-xs tracking-[0.3em] uppercase text-[#D4AF37]">Depoimentos</span>
            <div className="w-10 h-px bg-[#D4AF37]/40"></div>
          </div>
          <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl text-white mb-4">
            Histórias de <span className="italic text-[#D4AF37]">Transformação</span>
          </h2>
          <p className="text-base text-white/40 max-w-2xl mx-auto mb-12 font-light font-['Montserrat']">
            Veja como nossos planos têm ajudado profissionais a construírem o futuro que desejam
          </p>

          {/* Estatísticas */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5 max-w-4xl mx-auto">
            <div className="bg-white/[0.04] border border-[#D4AF37]/15 p-6 rounded-xl">
              <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                <i className="ri-star-fill text-2xl text-[#D4AF37]"></i>
              </div>
              <div className="font-['Playfair_Display'] text-3xl font-bold text-white mb-1">
                {estatisticasSatisfacao.notaMedia}
              </div>
              <div className="text-xs text-white/35 font-['Montserrat']">Nota Média</div>
            </div>

            <div className="bg-white/[0.04] border border-[#D4AF37]/15 p-6 rounded-xl">
              <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                <i className="ri-chat-smile-3-fill text-2xl text-[#D4AF37]"></i>
              </div>
              <div className="font-['Playfair_Display'] text-3xl font-bold text-white mb-1">
                {estatisticasSatisfacao.percentualRecomendacao}%
              </div>
              <div className="text-xs text-white/35 font-['Montserrat']">Recomendam</div>
            </div>

            <div className="bg-white/[0.04] border border-[#D4AF37]/15 p-6 rounded-xl">
              <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                <i className="ri-message-3-fill text-2xl text-[#D4AF37]"></i>
              </div>
              <div className="font-['Playfair_Display'] text-3xl font-bold text-white mb-1">
                {estatisticasSatisfacao.totalAvaliacoes.toLocaleString('pt-BR')}
              </div>
              <div className="text-xs text-white/35 font-['Montserrat']">Avaliações</div>
            </div>

            <div className="bg-white/[0.04] border border-[#D4AF37]/15 p-6 rounded-xl">
              <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                <i className="ri-group-fill text-2xl text-[#D4AF37]"></i>
              </div>
              <div className="font-['Playfair_Display'] text-3xl font-bold text-white mb-1">
                {estatisticasSatisfacao.usuariosAtivos.toLocaleString('pt-BR')}+
              </div>
              <div className="text-xs text-white/35 font-['Montserrat']">Usuárias Ativas</div>
            </div>
          </div>
        </div>

        {/* Carrossel de Depoimentos */}
        <div className="relative">
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-5 z-10 w-11 h-11 bg-white/[0.06] border border-[#D4AF37]/20 rounded-full flex items-center justify-center text-white/60 hover:bg-[#D4AF37]/20 hover:text-[#D4AF37] hover:border-[#D4AF37]/50 transition-all duration-300 cursor-pointer"
            aria-label="Depoimento anterior"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
            {currentDepoimentos.map((depoimento) => (
              <div
                key={depoimento.id}
                className="bg-white/[0.04] border border-[#D4AF37]/10 p-7 rounded-2xl hover:border-[#D4AF37]/30 transition-all duration-300 flex flex-col"
              >
                {/* Badge do Plano */}
                <div className="mb-5">
                  <span className="inline-block px-4 py-1.5 bg-[#D4AF37]/15 border border-[#D4AF37]/30 text-[#D4AF37] text-xs font-semibold rounded-full font-['Montserrat'] tracking-wide">
                    {depoimento.plano} · {depoimento.valorPlano}
                  </span>
                </div>

                {/* Estrelas */}
                <div className="flex gap-1 mb-4">
                  {[...Array(depoimento.nota)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-[#D4AF37] text-base"></i>
                  ))}
                </div>

                {/* Texto */}
                <blockquote className="text-white/55 leading-relaxed mb-6 flex-grow italic font-['Montserrat'] text-sm font-light border-l-2 border-[#D4AF37]/20 pl-4">
                  &ldquo;{depoimento.texto}&rdquo;
                </blockquote>

                {/* Resultado */}
                <div className="mb-5 p-4 bg-[#D4AF37]/8 rounded-xl border-l-4 border-[#D4AF37]">
                  <div className="flex items-start gap-2">
                    <i className="ri-trophy-fill text-[#D4AF37] text-lg mt-0.5"></i>
                    <div>
                      <div className="text-xs text-white/30 mb-1 font-['Montserrat'] uppercase tracking-wider">Resultado:</div>
                      <div className="text-sm font-semibold text-white/80 font-['Montserrat']">
                        {depoimento.resultado}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Perfil */}
                <div className="flex items-center gap-4 pt-5 border-t border-white/[0.06]">
                  <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 border border-[#D4AF37]/25">
                    <img
                      src={depoimento.foto}
                      alt={depoimento.nome}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <div className="font-semibold text-white text-sm font-['Montserrat']">{depoimento.nome}</div>
                    <div className="text-xs text-[#D4AF37]/70 font-['Montserrat']">Cliente Verificada</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-5 z-10 w-11 h-11 bg-white/[0.06] border border-[#D4AF37]/20 rounded-full flex items-center justify-center text-white/60 hover:bg-[#D4AF37]/20 hover:text-[#D4AF37] hover:border-[#D4AF37]/50 transition-all duration-300 cursor-pointer"
            aria-label="Próximo depoimento"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>

        {/* Indicadores */}
        <div className="flex justify-center gap-2 mt-10">
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
                index === currentIndex ? 'bg-[#D4AF37] w-8' : 'bg-white/15 hover:bg-white/30 w-2'
              }`}
              aria-label={`Ir para página ${index + 1}`}
            />
          ))}
        </div>

        {/* CTA Final */}
        <div className="text-center mt-14">
          <p className="text-sm text-white/35 mb-5 font-['Montserrat'] font-light">
            Junte-se a profissionais de alta performance que já transformaram suas mentes
          </p>
          <a
            href="#planos"
            className="inline-block px-8 py-3.5 bg-[#D4AF37] text-black font-['Montserrat'] font-semibold rounded-lg hover:bg-[#C5A028] transition-all duration-300 whitespace-nowrap cursor-pointer tracking-wide text-sm"
          >
            Escolher Meu Plano
          </a>
        </div>
      </div>
    </section>
  );
}
